<template>
    <footer class="footer">
        <div class="footer__inner">
            <template v-if="type === 'signin'">
                <h3 class="footer__heading">
                    Already a member?
                </h3>
                <router-link class="buffer-bottom" to="/">Sign in here</router-link>
                <p>
                    Having problems or want help?
                </p>
                <a :href="helpURL">Account help</a>
            </template>

            <template v-else-if="type === 'help'"> </template>
            <div class="footer-sponsors footer-sponsors--background" data-v-df6d28a4="" data-v-4784c86d="">
                <div class="footer-sponsors__inner" data-v-df6d28a4="">
                    <div class="footer-sponsors__row" data-v-df6d28a4="">
                        <h6 class="footer-sponsors__row-title h5" data-v-df6d28a4="">Principal Partners</h6>
                        <ol class="footer-sponsors__sponsor-wrapper footer-sponsors__sponsor-wrapper--large"
                            data-v-df6d28a4="">
                            <li class="footer-sponsors__sponsor footer-sponsors__sponsor--large" data-v-df6d28a4=""><a
                                    href="https://www.adidas.co.uk/football" target="_blank" rel="sponsored"
                                    alt="Link to adidas website" class="footer-sponsors__logo"
                                    style="background-image:url('https://img.gc.avfcservices.co.uk/fit-in/400x400/02a580a0-1f45-11ef-a5e1-450b275898ba.png');"
                                    data-v-df6d28a4="" data-uw-rm-brl="PR"
                                    data-uw-original-href="https://www.adidas.co.uk/football"
                                    aria-label="adidas.co.uk - open in a new tab" data-uw-rm-empty-ctrl=""
                                    data-uw-rm-ext-link=""
                                    uw-rm-external-link-id="https://www.adidas.co.uk/football$adidas.co.uk"></a></li>
                            <li data-v-df6d28a4="" class="footer-sponsors__sponsor footer-sponsors__sponsor--large"><a
                                    data-v-df6d28a4="" href="https://www.betano.co.uk/" target="_blank" rel="sponsored"
                                    alt="Link to Betano website" class="footer-sponsors__logo"
                                    style="background-image: url(&quot;https://img.gc.avfcservices.co.uk/fit-in/400x400/18a44d00-1f45-11ef-ab05-49c430a3bbaa.png&quot;);"
                                    data-uw-rm-brl="PR" data-uw-original-href="https://www.betano.co.uk/"
                                    aria-label="betano.co.uk - open in a new tab" data-uw-rm-empty-ctrl=""
                                    data-uw-rm-ext-link=""
                                    uw-rm-external-link-id="https://www.betano.co.uk/$betano.co.uk"></a></li>
                            <li data-v-df6d28a4="" class="footer-sponsors__sponsor footer-sponsors__sponsor--large"><a
                                    data-v-df6d28a4="" href="https://tradenation.com/" target="_blank" rel="sponsored"
                                    alt="Link to Trade Nation" class="footer-sponsors__logo"
                                    style="background-image: url(&quot;https://img.gc.avfcservices.co.uk/fit-in/400x400/40e3e240-9db2-11ee-ad50-79190ab7c8d1.png&quot;);"
                                    data-uw-rm-brl="PR" data-uw-original-href="https://tradenation.com/"
                                    aria-label="tradenation.com - open in a new tab" data-uw-rm-empty-ctrl=""
                                    data-uw-rm-ext-link=""
                                    uw-rm-external-link-id="https://tradenation.com/$tradenation.com"></a></li>
                                    <li class="footer-sponsors__sponsor footer-sponsors__sponsor--large">
                            <a
                                href="https://www.elgouna.com/"
                                target="_blank"
                                class="footer-sponsors__logo"
                                style="
                  background-image: url('https://images.webapi.gc.avfcservices.co.uk/fit-in/400x400/9eed5f20-fde5-11f0-8b64-61fafd37ced9.png');
                "
                            >
                            </a>
                        </li>
                        </ol>
                    </div>
                    <div class="footer-sponsors__row" data-v-df6d28a4="">
                        <h6 class="footer-sponsors__row-title h6" data-v-df6d28a4="">Official Partners</h6>
                        <ol class="footer-sponsors__sponsor-wrapper footer-sponsors__sponsor-wrapper--small"
                            data-v-df6d28a4="">
                            <li class="footer-sponsors__sponsor footer-sponsors__sponsor--small" data-v-df6d28a4=""><a
                                    href="https://www.coca-cola.com/gb/en" target="_blank" rel="sponsored"
                                    alt="Link to Coca-Cola Website" class="footer-sponsors__logo"
                                    style="background-image:url('https://img.gc.avfcservices.co.uk/fit-in/400x400/0f3d5810-826d-11f0-830f-e3f6a56bfcd7.png');"
                                    data-v-df6d28a4="" data-uw-rm-brl="PR"
                                    data-uw-original-href="https://www.coca-cola.com/gb/en"
                                    aria-label="coca-cola.com - open in a new tab" data-uw-rm-empty-ctrl=""
                                    data-uw-rm-ext-link=""
                                    uw-rm-external-link-id="https://www.coca-cola.com/gb/en$coca-cola.com"></a></li>
                            <li data-v-df6d28a4="" class="footer-sponsors__sponsor footer-sponsors__sponsor--small"><a
                                    data-v-df6d28a4="" href="https://www.guinness.com/en-gb" target="_blank"
                                    rel="sponsored" alt="Link to Guinness Website" class="footer-sponsors__logo"
                                    style="background-image: url(&quot;https://img.gc.avfcservices.co.uk/fit-in/400x400/13326000-826d-11f0-830f-e3f6a56bfcd7.png&quot;);"
                                    data-uw-rm-brl="PR" data-uw-original-href="https://www.guinness.com/en-gb"
                                    aria-label="guinness.com - open in a new tab" data-uw-rm-empty-ctrl=""
                                    data-uw-rm-ext-link=""
                                    uw-rm-external-link-id="https://www.guinness.com/en-gb$guinness.com"></a></li>
                            <li data-v-df6d28a4="" class="footer-sponsors__sponsor footer-sponsors__sponsor--small"><a
                                    data-v-df6d28a4="" href="https://www.carlsbergmarstons.co.uk/" target="_blank"
                                    rel="sponsored" alt="Link to Carlsberg Britvic website"
                                    class="footer-sponsors__logo"
                                    style="background-image: url(&quot;https://img.gc.avfcservices.co.uk/fit-in/400x400/15fac3a0-f2b6-11ef-97e6-8b9b0ee41d85.png&quot;);"
                                    data-uw-rm-brl="PR" data-uw-original-href="https://www.carlsbergmarstons.co.uk/"
                                    aria-label="carlsbergmarstons.co.uk - open in a new tab" data-uw-rm-empty-ctrl=""
                                    data-uw-rm-ext-link=""
                                    uw-rm-external-link-id="https://www.carlsbergmarstons.co.uk/$carlsbergmarstons.co.uk"></a>
                            </li>
                            <li data-v-df6d28a4="" class="footer-sponsors__sponsor footer-sponsors__sponsor--small"><a
                                    data-v-df6d28a4=""
                                    href="https://url.avanan.click/v2/r01/___https:/www.xapobank.com/en?utm_source=partnership&amp;amp;utm_medium=online&amp;amp;utm_campaign=owned_av25_avfcwebsite&amp;amp;utm_content=partners_page___.YXAzOmF2ZmM6YTpvOjNjZGQ4NDVjOWE3M2YzMzZjMzc4MWJkMDg3NGJhY2M0Ojc6ZmYxMTpiYmJhZDNjMzkxYWRmZTgyOGY4YjY1NzUxMTZkZGNhNTY0MmQzOGNhMzZmYWI0YTcyZDdjN2E1MTkzN2I5YzhkOmg6VDpG"
                                    target="_blank" rel="sponsored" alt="Link to Xapo Bank"
                                    class="footer-sponsors__logo"
                                    style="background-image: url(&quot;https://img.gc.avfcservices.co.uk/fit-in/400x400/ace06e70-8cc9-11f0-bc8f-8bae472f25d5.png&quot;);"
                                    data-uw-rm-brl="PR"
                                    data-uw-original-href="https://url.avanan.click/v2/r01/___https:/www.xapobank.com/en?utm_source=partnership&amp;amp;utm_medium=online&amp;amp;utm_campaign=owned_av25_avfcwebsite&amp;amp;utm_content=partners_page___.YXAzOmF2ZmM6YTpvOjNjZGQ4NDVjOWE3M2YzMzZjMzc4MWJkMDg3NGJhY2M0Ojc6ZmYxMTpiYmJhZDNjMzkxYWRmZTgyOGY4YjY1NzUxMTZkZGNhNTY0MmQzOGNhMzZmYWI0YTcyZDdjN2E1MTkzN2I5YzhkOmg6VDpG"
                                    aria-label="xapobank.com - open in a new tab" data-uw-rm-empty-ctrl=""
                                    data-uw-rm-ext-link=""
                                    uw-rm-external-link-id="https://url.avanan.click/v2/r01/___https:/www.xapobank.com/en?utm_source=partnership&amp;amp;utm_medium=online&amp;amp;utm_campaign=owned_av25_avfcwebsite&amp;amp;utm_content=partners_page___.yxazomf2zmm6ytpvojnjzgq4ndvjowe3m2yzmzzjmzc4mwjkmdg3ngjhy2m0ojc6zmyxmtpiymjhzdnjmzkxywrmztgyogy4yjy1nzuxmtzkzgnhnty0mmqzognhmzzmywi0ytcyzddjn2e1mtkzn2i5yzhkomg6vdpg$url.avanan.click"></a>
                            </li>
                        </ol>
                    </div>
                    <div class="footer-sponsors__row" data-v-df6d28a4=""><!---->
                        <ol class="footer-sponsors__sponsor-wrapper footer-sponsors__sponsor-wrapper--small"
                            data-v-df6d28a4="">
                            <li data-v-df6d28a4="" class="footer-sponsors__sponsor footer-sponsors__sponsor--small"><a
                                    data-v-df6d28a4="" href="https://nemiroff.vodka/en-uk/" target="_blank"
                                    rel="sponsored" alt="Link to Nemiroff website" class="footer-sponsors__logo"
                                    style="background-image: url(&quot;https://img.gc.avfcservices.co.uk/fit-in/400x400/e21dc9d0-a68c-11ef-8bc4-2b744177df40.png&quot;);"
                                    data-uw-rm-brl="PR" data-uw-original-href="https://nemiroff.vodka/en-uk/"
                                    aria-label="nemiroff.vodka - open in a new tab" data-uw-rm-empty-ctrl=""
                                    data-uw-rm-ext-link=""
                                    uw-rm-external-link-id="https://nemiroff.vodka/en-uk/$nemiroff.vodka"></a></li>
                            <li class="footer-sponsors__sponsor footer-sponsors__sponsor--small" data-v-df6d28a4=""><a
                                    href="https://ebury.com/" target="_blank" rel="sponsored"
                                    alt="Link to Ebury Website" class="footer-sponsors__logo"
                                    style="background-image:url('https://img.gc.avfcservices.co.uk/fit-in/400x400/6328ba50-5be4-11f0-a095-6bdce404b455.png');"
                                    data-v-df6d28a4="" data-uw-rm-brl="PR" data-uw-original-href="https://ebury.com/"
                                    aria-label="ebury.com - open in a new tab" data-uw-rm-empty-ctrl=""
                                    data-uw-rm-ext-link="" uw-rm-external-link-id="https://ebury.com/$ebury.com"></a>
                            </li>
                            <li data-v-df6d28a4="" class="footer-sponsors__sponsor footer-sponsors__sponsor--small"><a
                                    data-v-df6d28a4="" href="https://www.fantokens.com/trade/aston-villa-fan-token"
                                    target="_blank" rel="sponsored" alt="Link to Socios" class="footer-sponsors__logo"
                                    style="background-image: url(&quot;https://img.gc.avfcservices.co.uk/fit-in/400x400/00283f00-7379-11f0-a5d7-0d26a1b40e8c.png&quot;);"
                                    data-uw-rm-brl="PR"
                                    data-uw-original-href="https://www.fantokens.com/trade/aston-villa-fan-token"
                                    aria-label="fantokens.com - open in a new tab" data-uw-rm-empty-ctrl=""
                                    data-uw-rm-ext-link=""
                                    uw-rm-external-link-id="https://www.fantokens.com/trade/aston-villa-fan-token$fantokens.com"></a>
                            </li>
                            <li class="footer-sponsors__sponsor footer-sponsors__sponsor--small" data-v-df6d28a4=""><a
                                    href="https://www.esentire.com/" target="_blank" rel="sponsored"
                                    alt="Link to eSentire" class="footer-sponsors__logo"
                                    style="background-image:url('https://img.gc.avfcservices.co.uk/fit-in/400x400/03c720e0-e490-11ef-b536-3107729063c9.png');"
                                    data-v-df6d28a4="" data-uw-rm-brl="PR"
                                    data-uw-original-href="https://www.esentire.com/"
                                    aria-label="esentire.com - open in a new tab" data-uw-rm-empty-ctrl=""
                                    data-uw-rm-ext-link=""
                                    uw-rm-external-link-id="https://www.esentire.com/$esentire.com"></a></li>
                            <li class="footer-sponsors__sponsor footer-sponsors__sponsor--small" data-v-df6d28a4=""><a
                                    href="https://www.jdsports.co.uk/search/aston+villa/" target="_blank"
                                    rel="sponsored" alt="Link to JD Sports" class="footer-sponsors__logo"
                                    style="background-image:url('https://img.gc.avfcservices.co.uk/fit-in/400x400/f9ba0430-4f45-11ef-b119-f5996cfcbea7.png');"
                                    data-v-df6d28a4="" data-uw-rm-brl="PR"
                                    data-uw-original-href="https://www.jdsports.co.uk/search/aston+villa/"
                                    aria-label="search - open in a new tab" data-uw-rm-empty-ctrl=""
                                    data-uw-rm-ext-link=""
                                    uw-rm-external-link-id="https://www.jdsports.co.uk/search/aston+villa/$search"></a>
                            </li>
                            <li class="footer-sponsors__sponsor footer-sponsors__sponsor--small" data-v-df6d28a4=""><a
                                    href="https://shop.avfc.co.uk/en/?_s=bm-FI-PSC-AVFC-Footer" target="_blank"
                                    rel="sponsored" alt="Link to Fanatics" class="footer-sponsors__logo"
                                    style="background-image:url('https://img.gc.avfcservices.co.uk/fit-in/400x400/42e28060-4f46-11ef-b119-f5996cfcbea7.png');"
                                    data-v-df6d28a4="" data-uw-rm-brl="PR"
                                    data-uw-original-href="https://shop.avfc.co.uk/en/?_s=bm-FI-PSC-AVFC-Footer"
                                    aria-label="shop.avfc.co.uk - open in a new tab" data-uw-rm-empty-ctrl=""
                                    data-uw-rm-ext-link=""
                                    uw-rm-external-link-id="https://shop.avfc.co.uk/en/?_s=bm-fi-psc-avfc-footer$shop.avfc.co.uk"></a>
                            </li>
                            <li class="footer-sponsors__sponsor footer-sponsors__sponsor--small" data-v-df6d28a4=""><a
                                    href="https://seatgeek.com/" target="_blank" rel="sponsored" alt="Link to SeatGeek"
                                    class="footer-sponsors__logo"
                                    style="background-image:url('https://img.gc.avfcservices.co.uk/fit-in/400x400/8fe183d0-69d0-11ef-9263-3925a38dfac1.png');"
                                    data-v-df6d28a4="" data-uw-rm-brl="PR" data-uw-original-href="https://seatgeek.com/"
                                    aria-label="seatgeek.com - open in a new tab" data-uw-rm-empty-ctrl=""
                                    data-uw-rm-ext-link=""
                                    uw-rm-external-link-id="https://seatgeek.com/$seatgeek.com"></a></li>
                        </ol>
                    </div>
                    <div class="footer-sponsors__row" data-v-df6d28a4="">
                        <h6 class="footer-sponsors__row-title h6" data-v-df6d28a4="">Charity Partners</h6>
                        <ol class="footer-sponsors__sponsor-wrapper footer-sponsors__sponsor-wrapper--small"
                            data-v-df6d28a4="">
                            <li class="footer-sponsors__sponsor footer-sponsors__sponsor--small" data-v-df6d28a4=""><a
                                    href="#" target="_blank" rel="sponsored" alt="Link to Acorns"
                                    class="footer-sponsors__logo"
                                    style="background-image:url('https://img.gc.avfcservices.co.uk/fit-in/400x400/745cba80-2d15-11ec-ac61-fbd012182b17.png');"
                                    data-v-df6d28a4="" data-uw-rm-brl="PR" data-uw-original-href="#"
                                    aria-label="Acorns charity - open in a new tab" data-uw-rm-empty-ctrl=""
                                    data-uw-rm-ext-link=""
                                    uw-rm-external-link-id="https://www.avfc.co.uk/#$acornscharity"></a></li>
                            <li class="footer-sponsors__sponsor footer-sponsors__sponsor--small" data-v-df6d28a4=""><a
                                    href="https://bwc.nhs.uk/birmingham-childrens-hospital" target="_blank"
                                    rel="sponsored" alt="Link to Birmingham Children's Hospital Charity"
                                    class="footer-sponsors__logo"
                                    style="background-image:url('https://img.gc.avfcservices.co.uk/fit-in/400x400/7459d450-2d15-11ec-a923-f749ef7bcdc4.png');"
                                    data-v-df6d28a4="" data-uw-rm-brl="PR"
                                    data-uw-original-href="https://bwc.nhs.uk/birmingham-childrens-hospital"
                                    aria-label="bwc.nhs.uk - open in a new tab" data-uw-rm-empty-ctrl=""
                                    data-uw-rm-ext-link=""
                                    uw-rm-external-link-id="https://bwc.nhs.uk/birmingham-childrens-hospital$bwc.nhs.uk"></a>
                            </li>
                            <li class="footer-sponsors__sponsor footer-sponsors__sponsor--small" data-v-df6d28a4=""><a
                                    href="https://www.avfc.co.uk/foundation/" target="_blank" rel="sponsored"
                                    alt="Link to AV Foundation" class="footer-sponsors__logo"
                                    style="background-image:url('https://img.gc.avfcservices.co.uk/fit-in/400x400/814e1b10-828b-11f0-892c-b7e3a1bd786a.png');"
                                    data-v-df6d28a4="" data-uw-rm-brl="PR"
                                    data-uw-original-href="https://www.avfc.co.uk/foundation/"
                                    aria-label="avfc.co.uk - open in a new tab" data-uw-rm-empty-ctrl=""
                                    data-uw-rm-ext-link=""
                                    uw-rm-external-link-id="https://www.avfc.co.uk/foundation/$avfc.co.uk"></a></li>
                        </ol>
                    </div>
                </div>
            </div>

            <div class="legalLinks">
                <a href="https://www.avfc.co.uk/club/legal/privacy-policy">Privacy Policy</a>
            </div>
            <div class="legalLinks">
                This website is © {{ configStrings.clubName }} {{ year }}. All rights
                reserved
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: "FooterShout",
    data() {
        var d = new Date();
        return {
            helpURL: "https://www.avfc.co.uk/fans/digital-membership",
            year: d.getFullYear(),
        };
    },
    props: {
        type: {
            type: String, // register | signin | help
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.footer {
    position: relative;
    margin: 50px 0 0;
    padding: 60px 20px 80px;
    color: #fff;
    font-size: 18px;
    text-align: center;
    background-color: #322024;

    &:before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: transparent url("../assets/stadium-white-out@2x.png") center right no-repeat;
        background-size: cover;
        opacity: 0.4;
        z-index: 1;
    }

    &__inner {
        position: relative;
        z-index: 3;
    }

    &__heading {
        margin: 0 0 24px;
        font-size: 32px;
        font-weight: 300;

        >span {
            font-weight: 500;
        }
    }

    a {
        color: #fff;

        &:hover {
            color: #660033;
        }
    }

    &__telephone {
        margin: 10px 0 0;
        font-size: 34px;
        font-weight: 300;
    }
}

.buffer-bottom {
    display: inline-block;
    margin-bottom: 30px;
}

.features {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: flex-start;
    margin: 40px auto 0;
    padding: 0;
    max-width: 1200px;
    list-style: none;

    &__item {
        flex-grow: 1;
        flex-basis: 0;
        margin: 0 20px 30px;
        font-size: 15px;
        font-style: normal;
        font-weight: normal;
        line-height: 1.47;
        text-align: center;

        span {
            display: block;
        }

        &:before {
            content: "";
            display: block;
            margin: 0 auto 10px;
            height: 97px;
            width: 97px;
            background-color: rgba(255, 255, 255, 0.75);
            background-position: 50%;
            background-repeat: no-repeat;
            border: 2px solid #fff;
            border-radius: 50%;
        }

        &--store:before {
            background-image: url("../assets/features/retail.svg");
            background-size: 62px;
            background-position: 50% 45%;
        }

        &--plus:before {
            background-image: url("../assets/features/villa-plus.svg");
            background-size: 62px;
            background-position: 50% 45%;
        }

        &--live:before {
            background-image: url("../assets/features/villa-live.svg");
            background-size: 62px;
            background-position: 50% 45%;
        }

        &--app:before {
            background-image: url("../assets/features/app.svg");
            background-size: 62px;
        }

        &--ticketing {
            opacity: 0.5;

            &:before {
                background-image: url("../assets/features/tickets.svg");
                background-size: 62px;
            }
        }
    }
}

.legalLinks {
    margin-top: 20px;
    font-size: 1rem;
}

.footer-sponsors {
    // background-color: footerSetting(footer_sponsors-background_color);

    .h5 {
        font-size: 1.25em;
    }

    .h6 {
        font-size: 1em;
    }

    &__inner {
        max-width: 1440px;
        margin: 0 auto;
        padding-top: 26px;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;

        @media screen and (min-width: 760px) {
            padding-bottom: 8px;
        }
    }

    &__row {
        width: 100%;
    }

    &__row-title {
        // color: footerSetting(footer_sponsors-text_color);
        text-align: center;
    }

    &__sponsor-wrapper {
        margin: 0 auto;
        list-style-type: none;
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        padding-left: 0;

        &--small {
            justify-content: center;

            @media screen and (min-width: 760px) {
                max-width: 720px;
            }

            @media screen and (min-width: 1024px) {
                max-width: 1032px;
            }
        }

        &--large {
            padding-bottom: 16px;
            justify-content: center;

            @media screen and (min-width: 760px) {
                padding-bottom: 12px;
            }

            @media screen and (min-width: 1024px) {
                max-width: 1032px;
                padding-bottom: 0;
            }
        }
    }

    &__sponsor {
        display: flex;
        align-items: center;

        &--small {
            width: 80px;
            height: 80px;
            margin: 0 12px 24px;

            @media screen and (min-width: 760px) {
                width: 96px;
                height: 96px;
            }

            @media screen and (min-width: 1024px) {
                margin: 0 26px 24px;
            }
        }

        &--large {
            width: 132px;
            height: 132px;
            margin: 0 12px 24px;

            @media screen and (min-width: 375px) {
                width: 160px;
                height: 160px;
            }

            @media screen and (min-width: 760px) {
                margin: 0 20px 32px;
            }

            @media screen and (min-width: 1024px) {
                margin: 0 22px 28px;
            }
        }
    }

    &__logo {
        display: block;
        height: 100%;
        width: 100%;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }
}
</style>
